import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

export default function Hero() {
  const navigate = useNavigate();
  const [keyword, setKeyword] = useState('');

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (!keyword.trim()) return;
    navigate(`/ranking/popularity?q=${encodeURIComponent(keyword.trim())}`);
  };

  return (
    <section className="relative w-full overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=stylized%20webtoon%20manhwa%20art%20collage%20banner%2C%20colorful%20comic%20characters%20and%20dramatic%20scenes%20floating%20in%20warm%20vermilion%20amber%20and%20cream%20tones%2C%20abstract%20editorial%20background%2C%20vibrant%20flat%20illustration%2C%20rich%20layered%20composition&width=1600&height=900&seq=hero-2026-x1&orientation=landscape"
        alt="好看的韩国漫画精选合集"
        title="好看的韩国漫画排行榜 精选合集"
        className="absolute inset-0 h-full w-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/50 via-foreground-950/40 to-foreground-950/60" />

      <div className="relative mx-auto flex w-full max-w-7xl flex-col items-center justify-center px-4 py-20 text-center md:px-6 md:py-28">
        <span className="flex items-center gap-2 rounded-full border border-background-50/30 bg-background-50/10 px-4 py-1.5 text-sm text-background-50 backdrop-blur">
          <i className="ri-fire-fill text-accent-400" />
          人气榜 · 评分榜 · 必看榜 每日更新
        </span>

        <h1 className="mt-6 max-w-3xl font-heading text-3xl font-black leading-tight text-background-50 md:text-5xl">
          好看的韩国漫画排行榜
          <span className="mt-2 block text-accent-300">一站看遍高分韩漫</span>
        </h1>

        <p className="mt-5 max-w-2xl text-base leading-relaxed text-background-100/90 md:text-lg">
          聚合当下最热的韩漫人气榜、口碑最高的评分榜与入坑必看的必看榜，
          实时更新高分韩漫清单，帮你按热度与质量快速锁定最值得追的作品。
        </p>

        <div className="mt-8 flex flex-col items-center gap-3 sm:flex-row">
          <form onSubmit={handleSearch} className="flex w-full max-w-md items-center overflow-hidden rounded-full border border-background-50/30 bg-background-50/95 shadow-lg focus-within:border-primary-400">
            <i className="ri-search-line ml-4 text-sm text-foreground-400" />
            <input
              type="text"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索你喜欢的韩国漫画"
              className="w-full bg-transparent px-3 py-3 text-sm text-foreground-950 outline-none placeholder:text-foreground-400"
            />
            <button type="submit" className="m-1 flex shrink-0 items-center gap-1 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600">
              找好漫
            </button>
          </form>
        </div>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <Link to="/ranking/popularity" className="flex items-center gap-2 rounded-full bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600">
            <i className="ri-fire-line text-sm" />
            查看人气榜
          </Link>
          <Link to="/ranking/rating" className="flex items-center gap-2 rounded-full border border-background-50/40 bg-background-50/10 px-5 py-2.5 text-sm font-medium text-background-50 backdrop-blur transition-colors hover:bg-background-50/20">
            <i className="ri-star-line text-sm" />
            查看评分榜
          </Link>
        </div>
      </div>
    </section>
  );
}